import {v4 as uuid } from 'uuid';
import isEmpty from 'lodash/isEmpty';

export default async function launchFromDirectLink (page) {
    const {
        params,
    } = page;
    const env = this.env;
    const widgetStore = env.widgetStore;
    
    this.widgetSettings = {
        apikey: params.apiKey,
        host: window.location.origin,
    };

    if (this.isPreview) {
        this.widget = await widgetStore.getWidgetPreview();
        this.launchWidget();
        return;
    }

    const widget = await widgetStore.getWidget(params.widgetId);
    this.widget = widget;

    await this.selectTranslation();

    // console.log('laundh from directlink(): ', widget);
    if (isEmpty(widget?.id)) {
        this.observed.widget = uuid();
        return;
    }
    
    // When widget is not live, redirect to error page
    if (typeof widget !== "undefined" && !widget.isPublished) {
        this.env.errorsStore.dispatch({ code: 'BUTTON_NOT_LIVE' });
        this.env.appStore.gotoErrors();
        return;
    }

    this.attachWidgetBG();

    if (widget.directlink_logo) {
        this.directLinkLogo = widget.directlink_logo;
        this.observed.directLinkLogo = uuid();
    }

    this.launchWidget();
}

